"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetReplicaActiveKeywordRefsQuerySchema = exports.GetCampaignUpliftResponseSchema = exports.GetCampaignUpliftQuerySchema = exports.GetSpendDetailsResponseSchema = exports.GetSpendDetailsQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const SpendDetailsFields = {
    start: core_1.TimestampSchema,
    end: core_1.TimestampSchema,
    campaignRef: ruby_1.AppleProxyRefSchema,
};
exports.GetSpendDetailsQuerySchema = (0, core_1.StrictObject)(SpendDetailsFields);
exports.GetSpendDetailsResponseSchema = (0, core_1.StrictObject)({
    spent: core_1.MoneySchema,
    uplifted: core_1.MoneySchema,
});
exports.GetCampaignUpliftQuerySchema = (0, core_1.StrictObject)({
    ...SpendDetailsFields,
    useExact: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
});
exports.GetCampaignUpliftResponseSchema = (0, core_1.StrictObject)({
    uplifted: core_1.MoneySchema,
});
exports.GetReplicaActiveKeywordRefsQuerySchema = (0, core_1.StrictObject)({
    minimumImpressions: typebox_1.Type.Number({
        minimum: 0,
    }),
    from: core_1.TimestampSchema,
    to: core_1.TimestampSchema,
});
